import { useMemo } from 'react';
import useStandingAccessReports from './use-standing-access-reports';

export default function useGetReport(reportId: string) {
  const { reports, isFetched } = useStandingAccessReports();

  const report = useMemo(() => reports.find((r) => r.report.id === reportId), [reports, reportId]);

  return { report, isFetched };
}
